var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.classes
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-225b45ca","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Typography/Text.vue
// module id = 539
// module chunks = 0